import { Reveal } from "./Reveal";
import { Clock, ShieldCheck, FileCheck2, UserCheck } from "lucide-react";

const POINTS = [
  { icon: Clock, label: "24/7 emergency dispatch", sub: "Crews moving, day or night" },
  { icon: ShieldCheck, label: "IICRC-standard mitigation", sub: "Extraction, drying, monitoring" },
  { icon: FileCheck2, label: "Every loss documented", sub: "Dated record from arrival" },
  { icon: UserCheck, label: "We work for you", sub: "Never the carrier" },
];

export const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="relative pt-8 sm:pt-12">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-6 rounded-2xl border border-erg-ink/10 bg-white/50 px-6 py-6 sm:px-8">
            {POINTS.map((p, i) => (
              <div
                key={i}
                data-testid={`trust-point-${i}`}
                className={`flex items-start gap-3 ${
                  i < POINTS.length - 1 ? "lg:border-r lg:border-erg-ink/10 lg:pr-6" : ""
                }`}
              >
                <span className="mt-0.5 grid place-items-center h-9 w-9 shrink-0 rounded-lg bg-erg-mid/10 text-erg-mid">
                  <p.icon className="h-[18px] w-[18px]" strokeWidth={2} />
                </span>
                <span className="leading-tight">
                  <span className="block font-display font-semibold uppercase tracking-wide text-erg-ink text-[15px]">
                    {p.label}
                  </span>
                  <span className="block font-mono text-[11px] tracking-wide text-erg-ink/55 mt-0.5">
                    {p.sub}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
